<template>
  <div class="wrap">
    <el-row>
      <el-col :span="16">
        <Logo />
        <el-form :inline="true" :model="formInline" class="search-form">
          <el-form-item label="">
              <el-input v-model="formInline.keywords" size="small" style="width: 400px;" placeholder="input"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button size="small"  @click="onSearch">SEARCH</el-button>
              </el-form-item>
          </el-form>
      </el-col>
      <el-col :span="8" style="text-align: right;">
        <Navigation />
      </el-col>
    </el-row>
    <div class="fabric-main">
      <el-table
          :data="tableData"
          size="mini"
          v-loadmore="loadMore"
          height="350"
          style="width: 100%">
          <el-table-column
            label="Pic"
            width="180">
            <template slot-scope="scope">
              <img src="../../assets/da1.png" class="fabric-img" alt="">
            </template>
          </el-table-column>
          <el-table-column
            prop="name"
            label="Name"
            width="180">
          </el-table-column>
          <el-table-column
            prop="styleNo"
            label="Style No">
          </el-table-column>
          <el-table-column
            prop="composition"
            label="Composition">
          </el-table-column>
          <el-table-column
            prop="width"
            label="Width">
          </el-table-column>
          <el-table-column
            prop="weight"
            label="Weight">
          </el-table-column>
        </el-table>
    </div>
    <GoodsList />
  </div>
</template>

<script>
import Logo from '@/components/logo'
import Navigation from '@/components/navigation'
import GoodsList from '@/components/GoodsList'
export default {
  name: 'Fabric',
  components: {Logo, Navigation, GoodsList},
  data () {
    return {
      loadSign: true,
      formInline: {
        keyword: ''
      },
      tableData: [{
        name: 'RT Roman coated rinting',
        styleNo: '2110F053',
        composition: 'R/T/SP 64/31/5',
        width: '63"/160CM',
        weight: '390GSM'
      }, {
        name: 'RT Roman coated rinting',
        styleNo: '2110F053',
        composition: 'R/T/SP 64/31/5',
        width: '63"/160CM',
        weight: '390GSM'
      }, {
        name: 'RT Roman coated rinting',
        styleNo: '2110F053',
        composition: 'R/T/SP 64/31/5',
        width: '63"/160CM',
        weight: '390GSM'
      }, {
        name: 'RT Roman coated rinting',
        styleNo: '2110F053',
        composition: 'R/T/SP 64/31/5',
        width: '63"/160CM',
        weight: '390GSM'
      }, {
        name: 'RT Roman coated rinting',
        styleNo: '2110F053',
        composition: 'R/T/SP 64/31/5',
        width: '63"/160CM',
        weight: '390GSM'
      }, {
        name: 'RT Roman coated rinting',
        styleNo: '2110F053',
        composition: 'R/T/SP 64/31/5',
        width: '63"/160CM',
        weight: '390GSM'
      }, {
        name: 'RT Roman coated rinting',
        styleNo: '2110F053',
        composition: 'R/T/SP 64/31/5',
        width: '63"/160CM',
        weight: '390GSM'
      }, {
        name: 'RT Roman coated rinting',
        styleNo: '2110F053',
        composition: 'R/T/SP 64/31/5',
        width: '63"/160CM',
        weight: '390GSM'
      }]
    }
  },
  methods: {
    onSearch () {},
    loadMore () {
      console.log('load')
      if (this.loadSign) {
        this.loadSign = false
        setTimeout(() => {
          this.tableData.push({
            name: 'RT Roman coated rinting',
            styleNo: '2110F053',
            composition: 'R/T/SP 64/31/5',
            width: '63"/160CM',
            weight: '390GSM'
          })
          this.loadSign = true
        }, 1000)
        console.log('到底了', this.page)
      }
    }
  }
}
</script>

<style scoped>
.wrap {
  width: 1300px;
  margin: 0 auto;
}
.search-form {
  display: inline-block;
  float: left;
  margin-top: 20px;
}
.fabric-main {
  margin-top: 20px;
  border-top: 1px solid #dddddd;
}
.fabric-img {
  width: 30px;
  height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/views/fabric/index.vue